module.exports = __webpack_public_path__ + "img/violino-aperitivo.5b3bb152.jpg";